// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"5033941a","616":"00644218","665":"47c431d7","942":"277e9232"}[chunkId] + ".chunk.js";
};